<template>
    <div>
        <!--================ Start Header Menu Area =================-->
        <div class="wrap_head fixed" :class="{ 'fixed-login': user.hasLogin }">
            <!-- <div class="wrap_head" style="position: sticky;top: 0;z-index: 99;"> -->
            <div class="head_top">
                <div class="w_main">
                    <router-link class="logo" to="/">
                        <img src="../assets/logo_main.png" alt="">
                    </router-link>
                    <div class="user_area" v-if="user.hasLogin" to="/user">
                        <!-- 使用 el-tooltip 包裹图片 -->
                        <img class="icon_code" src="@/assets/image/wx_code.png" alt="服务微信">
                        <el-dropdown @command="handleCommand">
                            <span class="el-dropdown-link logout">
                                <span class="nickName">{{ (user.groupId == 1) ? user.name : user.company }}</span>
                                <div class="tx">
                                    <el-image v-if="user.groupId == 1" :src="user.avatar" fit="cover"
                                        style="width: 100%;height: 100%;border-radius: 50%;">
                                        <div slot="error" class="image-slot"
                                            style="font-size: 20px;text-align: center;">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="a">个人中心</el-dropdown-item>
                                <el-dropdown-item command="b">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="logo_area" v-else>
                        <!-- 使用 el-tooltip 包裹图片 -->
                        <img class="icon_code" src="@/assets/image/wx_code.png" alt="服务微信">
                        <div>
                            <el-link type="primary" @click="$store.commit('user/SET_LOGINDIGO', true)">用户登录</el-link> |
                            <el-link type="primary" @click="openRegister">用户注册</el-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="head_con">
                <ul class="menu_list" style="transform: translate(0px, 0px); opacity: 1;">
                    <li class="menu_item" @mouseenter="menuChange(item)" @mouseleave="menuChange({
                        value: -1
                    })" :class="{ 'active': item.value == activeIndex }" v-for="(item, index) in menuList"
                        :key="item.vaule">
                        <router-link class="txt" :to="item.path">{{ item.name }}</router-link>
                    </li>
                </ul>

            </div>

        </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Header',
  computed: mapState(['user', 'app']),
  data () {
    const validPhone = (rule, value, callback) => {
      if (!isPhoneno(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    return {
      scrollTop: 0,
      activeIndex: -1,
      loading: false,
      loginForm: {
        account: '', // 350581199011010535
        password: ''
      },
      menuList: [{ name: '首页', value: 0, path: '/' }, { name: '培训项目', value: 1, path: '/training' }, { name: '学习中心', value: 2, path: '/user' }, { name: '培训通知', value: 3, path: '/notification' }, { name: '公益视频', value: 5, path: '/commonwealVideo' }, { name: '关于我们', value: 4, path: '/about' }],
      loginRules: {
        account: [{ required: true, trigger: 'blur', message: '账号不可为空' }],
        password: [{ required: true, trigger: 'blur', message: '密码不可为空' }]
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    openRegister () {
      this.$router.push('/register')
    },
    handleClose (done) {
      done()
    },
    // 获取页面滚动距离
    handleScroll () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    menuChange (item) {
      this.activeIndex = item.value
    },
    handleCommand (command) {
      if (command == 'a') {
        this.$router.push('/user')
      } else if (command == 'b') {
        this.quitFun()
      }
    },
    quitFun () {
      console.log('=====')
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout').then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
          // location.reload() // 为了重新实例化vue-router对象 避免bug
          this.$router.push('/')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    transition: transform 0.3s ease;
}

.fixed-login {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999 !important;
    width: 100%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    transition: transform 0.3s ease;
}

.wrap_head {
    display: block;
    width: 100%;
    transition: all 0.2s linear;
    background-color: #fff;

    .head_top {
        background: #fff;
        height: 94px;
        display: block;
        width: 1200px;
        margin: 0px auto;
        position: relative;
        z-index: 2;

        .w_main {
            height: 94px;
        }

        .logo {
            display: flex;
            align-items: center;
            width: 326px;
            height: 100%;

            &:-webkit-any-link:focus-visible {
                outline-offset: 0px;
            }

            img {
                display: inline-block;
                height: 60px;
                width: auto;
                position: relative;
                top: 5px;
            }

            h1 {
                display: inline-block;
                font-size: 20px;
                display: block;
                color: #333333;
            }
        }

        .logo_area {
            display: flex;
            align-items: center;
            position: absolute;
            right: 0px;
            top: 0;
            font-size: 14px;
            color: #205dae;
            height: 94px;

            .icon_code {
                width: 80px;
                height: 80px;
                margin-right: 20px;
            }
        }

        .user_area {
            display: flex;
            align-items: center;
            position: absolute;
            right: 0px;
            top: 0;
            font-size: 16px;
            color: #333333;
            height: 94px;

            .icon_code {
                width: 80px;
                height: 80px;
                margin-right: 20px;
            }

            .nickName {
                margin-right: 12px;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
            }

            .tx {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
        }
    }

    .head_con {
        background: #205dae;
        display: block;
        width: 100%;
        min-width: 1200px;
        height: 46px;
        margin: 0px auto;
        position: relative;
        z-index: 2;

        .menu_list {
            display: block;
            margin: 0 auto;
            width: 1200px;
            height: 46px;
            cursor: pointer;
            opacity: 1;
            transition: opacity 0.3s linear;
            transform: translate(0px, 0);

            .menu_item {
                display: inline-block;
                height: 46px;
                float: left;
                width: 200px;
                position: relative;
                text-align: center;

                .txt {
                    display: block;
                    height: 46px;
                    line-height: 46px;
                    font-size: 20px;
                    color: #FFFFFF;
                    opacity: 0.95;
                    position: relative;
                    z-index: 2;
                }

                &.active {
                    background-color: #007ea7;
                }

                // &.active .txt {
                //     color: #CD2312;
                // }

                &.active::after {
                    content: '';
                    height: 2px;
                    width: 27px;
                    background-color: #007ea7;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    border-radius: 1px;
                }

            }
        }
    }
}

.logout {
    display: flex;
    align-items: center;
}

.title-container {
    padding: 26px 0;
    text-align: center;
}
</style>
